import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface State {
  showResourceIds: boolean;
  pretendToBeNonMemoryUser: boolean;
  simulatedRevisionCookie: string | null;
  maskFullStory: boolean;
  injectSyntheticData: boolean;
  throwRouteError: boolean;
  showStackTraceModal: boolean;
  initialStackTrace: string;
  excludeTrackerEntriesFromTimelyApiRequest: boolean;
  forceShowInstallMemoryMessage: boolean;
}

const initialState: State = {
  showResourceIds: false,
  pretendToBeNonMemoryUser: false,
  simulatedRevisionCookie: null,
  maskFullStory: false,
  injectSyntheticData: false,
  throwRouteError: false,
  showStackTraceModal: false,
  initialStackTrace: '',
  excludeTrackerEntriesFromTimelyApiRequest: false,
  forceShowInstallMemoryMessage: false,
};

const developmentSlice = createSlice({
  name: 'development',
  initialState,
  reducers: {
    setShowResourceIds: (state, action: PayloadAction<boolean>) => {
      state.showResourceIds = action.payload;
    },
    setPretendToBeNonMemoryUser: (state, action: PayloadAction<boolean>) => {
      state.pretendToBeNonMemoryUser = action.payload;
    },
    simulateOverrideRevisionCoookie: (state, action: PayloadAction<string | null>) => {
      state.simulatedRevisionCookie = action.payload;
    },
    setMaskFullStory: (state, action: PayloadAction<boolean>) => {
      state.maskFullStory = action.payload;
    },
    setInjectSyntheticData: (state, action: PayloadAction<boolean>) => {
      state.injectSyntheticData = action.payload;
    },
    setThrowRouteError: (state, action: PayloadAction<boolean>) => {
      state.throwRouteError = action.payload;
    },
    setShowStackTraceModal: (
      state,
      action: PayloadAction<boolean | [show: boolean, initialStackTrace: string]>
    ) => {
      if (Array.isArray(action.payload)) {
        const [show, initialStackTrace] = action.payload;
        state.showStackTraceModal = show;
        state.initialStackTrace = show ? initialStackTrace : '';
      } else {
        state.showStackTraceModal = action.payload;
        state.initialStackTrace &&= '';
      }
    },
    setExcludeTrackerEntriesFromTimelyApiRequest: (state, action: PayloadAction<boolean>) => {
      state.excludeTrackerEntriesFromTimelyApiRequest = action.payload;
    },
    setForceShowInstallMemoryMessage: (state, action: PayloadAction<boolean>) => {
      state.forceShowInstallMemoryMessage = action.payload;
    },
  },
});

export default developmentSlice.reducer;

export const {
  setShowResourceIds,
  setPretendToBeNonMemoryUser,
  simulateOverrideRevisionCoookie,
  setMaskFullStory,
  setInjectSyntheticData,
  setThrowRouteError,
  setShowStackTraceModal,
  setExcludeTrackerEntriesFromTimelyApiRequest,
  setForceShowInstallMemoryMessage,
} = developmentSlice.actions;
